// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    enableTourLines: true,
    isEnabled: true,
    production: false,
    encryptionKey: 'secret key 123',
    apiEndPoint: 'https://amgmaa-dev.mercedes-benz.com/aca',

    proxyEndpoint: 'https://proxy.dev.stories.me/customerPortal',
    // proxyEndpoint: 'http://localhost:4202/customerPortal',

    apikey: 'dummy-api-key', // to be retrieved from the backend or a secure store
    aesBaseUrl: 'https://apis.dev.business.stories.me/aes',
    newraceUrl: 'https://apis.dev.business.stories.me/aes/',
    appRedirectUrl: 'https://dev.stories4.me',
    domain: 'https://dev.stories.me/en-GB',
    localDealerShipUrl:'https://www.mercedes-amg.com/en/dealer',
    exploreGclassEventsUrl: 'https://g-class-experience.com/en/',
    exploreAmgEventsUrl: 'https://experience.mercedes-amg.com/en/',

    supported_language: ['en-GB', 'en', 'de', 'de-DE', 'fr-FR', 'es-ES', 'cs-CZ', 'ko-KR', 'it-IT'],
    featureFlagLink: '../../assets/json/feature-flag.json',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
